import React from 'react'
import "./Home.css";
import Product from "../Product/Product";
function Home() {
  return <div className="home">
      <img
        className="home_image"
        src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
      />
      <div className="home_row">
        <Product
          id="1212121"
          title="CyberpowerPC Gamer Xtreme VR Gaming PC, Intel i5-10400F 2.9GHz, GeForce GTX 1660 Super 6GB, 8GB DDR4, 500GB NVMe SSD, Wi-Fi Ready & Windows 10 Home (GXiVR8060A10)"
          price={1999.0}
          rating={5}
          image="https://m.media-amazon.com/images/I/818SNa1ruZL._AC_UL320_.jpg"
        />
        <Product
          id="1212121"
          title="SweatyRocks Women's Casual Heart Print Long Sleeve Pullover Hoodie Sweatshirt Tops"
          price={24}
          rating={5}
          image="https://m.media-amazon.com/images/I/71r2sik24AL._AC_UL320_.jpg"
        />

      
      </div>
      <div className="home_row">
        <Product
          id="1212121"
          title="Oculus Rift S PC-Powered VR Gaming Headset"
          price={479}
          rating={5}
          image="https://m.media-amazon.com/images/I/71URNvzoWqL._AC_UY218_.jpg"
        />
         <Product
          id="1212121"
          title="RESPAWN RSP-110 Racing Style Gaming, Reclining Chair with Footrest, Red"
          price={174.6}
          rating={5}
          image="https://m.media-amazon.com/images/I/71qYGd8XJ7L._AC_UL320_.jpg"
        />
         <Product
          id="1212121"
          title="Fitbit Charge 4 Fitness and Activity Tracker with Built-in GPS, Heart Rate, Sleep & Swim Tracking, Black/Black, One Size (S &L Bands Included)"
          price={99}
          rating={5}
          image="https://m.media-amazon.com/images/I/71smqRr0pmL._AC_UL320_.jpg"
        />
        </div>
      <div className="home_row">
        <Product
          id="1212121"
          title="FLYBIRD Weight Bench, Adjustable Strength Training Bench for Full Body Workout with Fast Folding- 2021 Version
          "
          price={12.4}
          rating={5}
          image="https://m.media-amazon.com/images/I/61mHRNtUdAL._AC_UL320_.jpg"
        />
        </div>
    </div>
  
}

export default Home;

